module.exports = __webpack_public_path__ + "static/media/Tablas_V2.f33b2240.png";